import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledLockedFreeSearchChip = styled('div')(
  () => css`
    &.locked-free-search-chip {
      display: flex;
      align-items: center;
      gap: 8px;
      height: 48px;
      padding: 12px;
      border-radius: 6px;
      border: 1px solid #f5f5f5;
      background: #fff;
      box-sizing: border-box;
      flex-shrink: 0;
      color: #6c879b;
      font-size: 14px;
      line-height: 20px;
      white-space: nowrap;
      user-select: none;
      cursor: default;
      transition: background-color 0.15s ease, border-color 0.15s ease,
        color 0.15s ease;

      .locked-free-search-chip__label {
        display: flex;
        align-items: center;
        gap: 6px;
      }

      &:hover {
        background: #fffbf0;
        border-color: #ffd666;
        color: #0c395a;
      }
    }
  `
);
